/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UtenteAppartenenzaConFederazioneDto } from '../../models/utente-appartenenza-con-federazione-dto';

export interface ApiAuthUtenteAppartenenzaListGet$Params {
    /**
     * Id dell'utente per cui caricare le associazioni
     */
    utenteId: number;
}

export function apiAuthUtenteAppartenenzaListGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthUtenteAppartenenzaListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<UtenteAppartenenzaConFederazioneDto>>> {
    const rb = new RequestBuilder(rootUrl, apiAuthUtenteAppartenenzaListGet.PATH, 'get');
    if (params) {
        rb.query('utenteId', params.utenteId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<UtenteAppartenenzaConFederazioneDto>>;
        }),
    );
}

apiAuthUtenteAppartenenzaListGet.PATH = '/api/auth/utente-appartenenza-list';
